import { ScreenSize } from '../constants/screenSizes';

export const calculateScreenWidth = () => window.innerWidth || window.outerWidth || 0;

export const isDesktop = () => {
  const screenSize = calculateScreenWidth();
  return screenSize >= ScreenSize.DesktopNarrow;
};
